export default [
    {
        path: "/admin/company-cadres",
        component: () => import("../Components/List.vue"),
        name: "company-cadres-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company-cadres/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "company-cadres-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company-cadres/create",
        component: () => import("../Components/Create.vue"),
        name: "company-cadres-create",
        meta: {
            requiresAuth: true,
        },
    },
];
